<template>
  <div :class="baseClass">
    <component :is="headingTag" ref="heading" :class="classes">
      {{ headingText }}
    </component>
    <slot />
  </div>
</template>

<script>
export default {
  name: "ModuleWithHeading",
  props: {
    /**
     * The Heading Level to Display
     */
    headingLevel: {
      type: Number,
      default: 2
    },
    /**
     * The Heading Text
     */
    headingText: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      /**
       * The base css class
       */
      baseClass: "a-module-heading"
    };
  },
  computed: {
    /**
     * The classes to apply to the component
     *
     * @returns {array}
     */
    classes() {
      let classes = [this.baseClass + "__heading"];
      classes.push(this.baseClass + "__heading--" + this.headingTag);
      return classes;
    },
    /**
     * The heading tag
     * @return {string}
     */
    headingTag() {
      return "h" + this.headingLevel;
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
